import React from 'react';
import { IIcon } from '@/components/icon/Icon.types';

export enum IconButtonTheme {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export interface IconButtonProps {
  className?: string;
  action: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  icon: IIcon;
  srText: string;
  tooltipText?: string;
  iconColor?: string;
  theme?: IconButtonTheme;
  onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>;
}
